import React, { useEffect } from "react";
import { Text } from "../../text";
import { defaultStyles } from "../../../../constants/style-constants/utils";
import Modal from "../modal";
import { Button } from "../../button";
import * as Style from "./styles/custom-modal";
import { Icon, DatePicker, InputNumber } from "antd";
import { Input } from "../../../input/Input";
import { InputGroup1 } from "../../input/styles/input";
import DropDown from "../../dropdown/dropdown";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import moment from "moment";
import { Select } from "antd";
import NewLoader from "../../loader/NewLoader";
import PhoneNumber from "../../../form/components/Countrycode";
const { Option } = Select;

function CustomModal({
  show,
  close,
  fields,
  submitData,
  modalTitle,
  obj,
  onChange,
  selectedRowData,
  onSelectChange,
  dropdownOptionsLiabilites,
  dropdownOptionsAssets,
  setFormData,
  handleItemsInfoImageChange,
  loading,
}) {
  const { styles } = defaultStyles;

  const handleSubmit = () => {
    submitData();
    close();
  };
  const history = useHistory();
  let DropDownValues = [
    { id: 1, value: "Bookkeeper" },
    { id: 2, value: "CPA" },
    { id: 3, value: "Financial Advisor" },
  ];
  useEffect(() => {
    if (fields) {
      !fields.attributes &&
        history.push({
          pathname: "/collectibles_new",
        });
    }
  }, [fields]);

  const mappingRules = {
    "Financial Accounts Informations": {
      Account: ["Nickname of Liabilities"],
      "Account Numbers": ["Account Number"],
      "Current Balances": [
        "Loan Balance",
        "Credit Balance",
        "Initial Loan Amount",
      ],
      "Date Openend": ["Start Date", "Credit Card Open Date"],
    },
    "Financial Accounts Information": {
      Account: ["Name of Asset"],
      "Account Number": ["Account Number"],
      "Current Balance": ["Monetary Value", "Cost Basis"],
      "Date Openend": ["Cost Basis", "Value as of Date"],
    },
    "Real Estate Information": {
      "Title Information": ["Name of Asset"],
      "Purchase Price": ["Cost Basis"],
      "Current Value": ["Monetary Value", "Cost Basis"],
      "Date Acquired": ["Cost Basis", "Value as of Date"],
    },
    "Vehicle Information Divorce":{
      "Current Value": ["Monetary Value", "Cost Basis"],
      "Vehicle": ["Name of Asset"],
    },
   "Personal Property Information":{
      "Current Value": ["Monetary Value", "Cost Basis"],
      "Personal Property": ["Name of Asset"],
    } 
  };


  function generateFormData(selectedData, fields, modalTitle) {
    var formData = {};
    if (fields && fields.attributes) {
      for (var i = 0; i < fields.attributes.length; i++) {
        var keyName = fields.attributes[i].name;
        var rules =
          mappingRules[modalTitle] && mappingRules[modalTitle][keyName];
        if (rules) {
          var value = "";
          for (var j = 0; j < rules.length; j++) {
            if (selectedData && selectedData[rules[j]]) {
              value = selectedData[rules[j]];
              break;
            }
          }
          formData[keyName] = value;
        } else {
          formData[keyName] = (selectedData && selectedData[keyName]) || "";
        }
      }
    }
    return formData;
  }

  return (
    <Modal show={show}>
      <Style.HeaderConatiner>
        <Text style={styles.text.formHeaderText}>{modalTitle}</Text>
        <Icon type="close" onClick={close}></Icon>
      </Style.HeaderConatiner>

      <Style.FieldsContainer>
        {dropdownOptionsLiabilites &&
          modalTitle === "Financial Accounts Informations" && (
            <InputGroup1>
              <div style={styles.text.labelText} padding="2rem 0 1rem 0 ">
                Select Liability
              </div>
              <Select
                showSearch
                name="Select Liability"
                title="Select Liability"
                disabled={modalTitle === "View Item"}
                id="Select Liability"
                placeholder="-Select-"
                onChange={(value) => {
                  var selectedData = null;
                  if (dropdownOptionsLiabilites) {
                    selectedData = dropdownOptionsLiabilites.find(function (
                      item
                    ) {
                      return item.id === value;
                    });
                  }
                  var formData = generateFormData(
                    selectedData,
                    fields,
                    modalTitle
                  );
                  setFormData(formData);
                  console.log("formData Liability:", formData);
                }}
              >
                {dropdownOptionsLiabilites &&
                  dropdownOptionsLiabilites.map(function (states, index) {
                    return (
                      <Option key={index} value={states.id}>
                        {states["Nickname of Liabilities"] || ""}
                      </Option>
                    );
                  })}
              </Select>
            </InputGroup1>
          )}

        {dropdownOptionsAssets && modalTitle && ["Real Estate Information","Personal Property Information","Vehicle Information","Vehicle Information Divorce","Financial Accounts Information"].includes(modalTitle)  && (
          <InputGroup1>
            <div style={styles.text.labelText} padding="2rem 0 1rem 0 ">
              Select Asset
            </div>
            <Select
              showSearch
              name="Select Asset"
              title="Select Asset"
              disabled={modalTitle === "View Item"}
              id="Select Asset"
              placeholder="-Select-"
              onChange={(value) => {
                var selectedData = null;
                if (dropdownOptionsAssets) {
                  selectedData = dropdownOptionsAssets.find(function (item) {
                    return item.id === value;
                  });
                }
                var formData = generateFormData(
                  selectedData,
                  fields,
                  modalTitle
                );
                setFormData(formData);
                console.log("formData Asset:", formData);
              }}
            >
              {dropdownOptionsAssets &&
                dropdownOptionsAssets.map(function (states, index) {
                  return (
                    <Option key={index} value={states.id}>
                      {states["Name of Asset"] || ""}
                    </Option>
                  );
                })}
            </Select>
          </InputGroup1>
        )}

        {fields &&
          fields.attributes &&
          fields.attributes.map((input, index) => {
            if (
              input.name !== "Uploaded File Name" &&
              (input.dataType.toLowerCase() === "string" ||
                input.dataType.toLowerCase() === "formula")
            ) {
              return (
                <InputGroup1 key={index}>
                  <div style={styles.text.labelText} padding="2rem 0 1rem 0 ">
                    {input.name}
                  </div>
                  <Input
                    placeholder={input.name}
                    name={input.name}
                    type="text"
                    disabled={
                      input.dataType.toLowerCase() === "formula" ||
                      modalTitle === "View Item"
                        ? true
                        : false
                    }
                    style={{
                      opacity:
                        input.dataType.toLowerCase() === "formula"
                          ? "0.6"
                          : "1",
                      cursor:
                        input.dataType.toLowerCase() === "formula"
                          ? "not-allowed"
                          : "",
                    }}
                    value={selectedRowData && selectedRowData[input.name]}
                    // onChange={(event) => handleContactInfo(event)}
                    onChange={(event) => onChange(event)}
                  />
                </InputGroup1>
              );
            } else if (input.dataType.toLowerCase() === "int") {
              return (
                <InputGroup1 key={index}>
                  <div style={styles.text.labelText} padding="2rem 0 1rem 0 ">
                    {input.name}
                  </div>
                  <div className="inputWrapper" style={{ display: "flex" }}>
                    {!["Approx. Age", "Number", "Size"].some((str) =>
                      input.name.includes(str)
                    ) && <span className="dollar-sign-with-input">$</span>}
                    <InputNumber
                      step={1}
                      formatter={(value) =>
                        `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                      }
                      // parser={(value) => value.replace(/\$\s?|(,*)/g, "")}
                      parser={(value) => value.replace(/[^\d]/g, "")} // Allow only digits
                      onKeyPress={(e) => {
                        if (!/[0-9]/.test(e.key)) {
                          e.preventDefault();
                        }
                      }}
                      className="Input"
                      placeholder={input.name}
                      name={input.name}
                      disabled={
                        input.dataType.toLowerCase() === "formula" ||
                        modalTitle === "View Item"
                          ? true
                          : false
                      }
                      style={{
                        opacity:
                          input.dataType.toLowerCase() === "formula"
                            ? "0.6"
                            : "1",
                        cursor:
                          input.dataType.toLowerCase() === "formula"
                            ? "not-allowed"
                            : "",
                      }}
                      value={selectedRowData && selectedRowData[input.name]}
                      id="amount"
                      onChange={(value) => {
                        const event = {
                          target: {
                            value: value,
                            name: input.name,
                          },
                        };
                        onChange(event);
                        // handleChange("amount", value);
                      }}
                    />
                  </div>
                </InputGroup1>
              );
            } else if (input.dataType.toLowerCase() === "float") {
              return (
                <InputGroup1 key={index}>
                  <div style={styles.text.labelText} padding="2rem 0 1rem 0 ">
                    {input.name}
                  </div>
                  <div className="inputWrapper" style={{ display: "flex" }}>
                    <span className="dollar-sign-with-input">$</span>
                    <InputNumber
                      step={1}
                      formatter={(value) =>
                        `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                      }
                      parser={(value) => value.replace(/\$\s?|(,*)/g, "")}
                      onKeyPress={(e) => {
                        if (!/[0-9]/.test(e.key)) {
                          e.preventDefault();
                        }
                      }}
                      className="Input"
                      placeholder={input.name}
                      name={input.name}
                      disabled={
                        input.dataType.toLowerCase() === "formula" ||
                        modalTitle === "View Item"
                          ? true
                          : false
                      }
                      style={{
                        opacity:
                          input.dataType.toLowerCase() === "formula"
                            ? "0.6"
                            : "1",
                        cursor:
                          input.dataType.toLowerCase() === "formula"
                            ? "not-allowed"
                            : "",
                      }}
                      value={selectedRowData && selectedRowData[input.name]}
                      id="amount"
                      onChange={(value) => {
                        const event = {
                          target: {
                            value: value,
                            name: input.name,
                          },
                        };
                        onChange(event);
                        // handleChange("amount", value);
                      }}
                    />
                  </div>
                </InputGroup1>
              );
            } else if (input.dataType.toLowerCase() === "percentage") {
              return (
                <InputGroup1 key={index}>
                  <div style={styles.text.labelText} padding="2rem 0 1rem 0 ">
                    {input.name}
                  </div>
                  <div className="inputWrapper" style={{ display: "flex" }}>
                    <InputNumber
                      step={1}
                      formatter={(value) =>
                        `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                      }
                      parser={(value) => value.replace(/\$\s?|(,*)/g, "")}
                      onKeyPress={(e) => {
                        if (!/[0-9]/.test(e.key)) {
                          e.preventDefault();
                        }
                      }}
                      className="Input"
                      placeholder={input.name}
                      name={input.name}
                      disabled={
                        input.dataType.toLowerCase() === "formula" ||
                        modalTitle === "View Item"
                          ? true
                          : false
                      }
                      style={{
                        opacity:
                          input.dataType.toLowerCase() === "formula"
                            ? "0.6"
                            : "1",
                        cursor:
                          input.dataType.toLowerCase() === "formula"
                            ? "not-allowed"
                            : "",
                      }}
                      value={selectedRowData && selectedRowData[input.name]}
                      id="amount"
                      onChange={(value) => {
                        const event = {
                          target: {
                            value: value,
                            name: input.name,
                          },
                        };
                        onChange(event);
                        // handleChange("amount", value);
                      }}
                    />
                    <span
                      style={{
                        fontSize: "15px",
                        padding: "8px",
                        display: "flex",
                        alignItems: "center",
                        color: "rgba(0, 0, 0, 0.65)",
                        background: "#fafafa",
                        borderRadius: "4px",
                        border: "1px solid #d1d5db",
                      }}
                    >
                      %
                    </span>
                  </div>
                </InputGroup1>
              );
            } else if (
              input.dataType.toLowerCase() === "phone number" &&
              input.name === "Phone Number"
            ) {
              return (
                <InputGroup1 key={index}>
                  <div style={styles.text.labelText} padding="2rem 0 1rem 0 ">
                    {input.name}
                  </div>
                  <PhoneNumber
                    id="phone"
                    name={input.name}
                    value={
                      selectedRowData &&
                      selectedRowData[input.name] &&
                      selectedRowData[input.name]
                    }
                    // onKeyPress={handleKeyPress}
                    onChange={(value) => {
                      const event = {
                        target: {
                          value: value.target.value,
                          name: input.name,
                        },
                      };
                      onChange(event);
                      // handleChange("amount", value);
                    }}
                    size="large"
                    placeholder={input.placeholder}
                  />
                </InputGroup1>
              );
            } else if (
              input.dataType.toLowerCase() == "calender" ||
              input.dataType.toLowerCase() == "date"
            ) {
              return (
                <InputGroup1 key={index}>
                  <div style={styles.text.labelText} padding="2rem 0 1rem 0 ">
                    {input.name}
                  </div>
                  <DatePicker
                    disabled={modalTitle === "View Item" ? true : false}
                    style={{
                      width: "100%",
                      border: "1px solid #d1d5db",
                      borderRadius: "5px",
                    }}
                    size="large"
                    format={"MM/DD/YYYY"}
                    placeholder={input.name}
                    name={input.name}
                    value={
                      selectedRowData && selectedRowData[input.name]
                        ? moment(selectedRowData[input.name])
                        : null
                    }
                    id="newDate"
                    onChange={(date, dateString) => {
                      const event = {
                        target: {
                          value: dateString,
                          name: input.name,
                        },
                      };
                      onChange(event);
                    }}
                  />
                  {/* <Input
                    placeholder={input.name}
                    name={input.name}
                    type="date"
                    disabled={modalTitle === "View Item" ? true : false}
                    value={selectedRowData && moment(selectedRowData[input.name]).format("YYYY-MM-DD")}
                    // onChange={(event) => handleContactInfo(event)}
                    onChange={(event) => {
                      onChange(event);
                    }}
                  />*/}
                </InputGroup1>
              );
            } else if (
              input.dataType.toLowerCase() === "image" &&
              !input.button
            ) {
              return (
                <InputGroup1 key={index}>
                  <div style={styles.text.labelText} padding="2rem 0 1rem 0 ">
                    {input.name}
                  </div>
                  <Input
                    placeholder={input.name}
                    name={input.name}
                    type="file"
                    disabled={modalTitle === "View Item" ? true : false}
                    // onChange={(event) => handleContactInfo(event)}
                    onChange={(event) => handleItemsInfoImageChange(event)}
                  />
                  {console.log("selectedRowData", selectedRowData)}
                  {selectedRowData &&
                  selectedRowData[input.name] &&
                  Array.isArray(selectedRowData[input.name]) ? (
                    selectedRowData[input.name][0] && (
                      <div>
                        <a
                          href={selectedRowData[input.name][0]}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          View Uploaded Document
                        </a>
                      </div>
                    )
                  ) : (
                    <div>
                      {selectedRowData && selectedRowData[input.name] && (
                        <a
                          href={selectedRowData[input.name]}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          View Uploaded Document
                        </a>
                      )}
                    </div>
                  )}
                </InputGroup1>
              );
            } else if (input.dataType.toLowerCase() === "dropdown") {
              return (
                <InputGroup1>
                  <div style={styles.text.labelText} padding="2rem 0 1rem 0 ">
                    {input.name}
                  </div>
                  <Select
                    showSearch
                    name={input.name}
                    title={input.name}
                    disabled={modalTitle === "View Item" ? true : false}
                    id={input.name}
                    placeholder="-Select-"
                    // defaultValue={
                    //   payload && payload[item.name] ? payload[item.name] : ""
                    // }
                    defaultValue={
                      selectedRowData && selectedRowData[input.name]
                    }
                    onChange={(value) => {
                      onSelectChange(input.name, value);
                    }}
                    // size={size}
                  >
                    {input.attribute_default_values.map((states, index) => (
                      <Option key={index} value={states.value}>
                        {states.value}
                      </Option>
                    ))}
                  </Select>
                  {/*  <DropDown
                    style={defaultStyles.styles.dropDown.m_smallDropdown}
                    listingStyle={{
                      ...defaultStyles.styles.dropDown.m_smallDropdown,
                      height: "auto",
                    }}
                    name={input.name}
                    title={input.name}
                    list={[
                      { id: 1, value: "Bookkeeper" },
                      { id: 2, value: "CPA" },
                      { id: 3, value: "Financial Advisor" },
                    ]}
                    displayKey="value"
                    disableSearch={false}
                    setSelectedItem={(event) => onChange(event.target)}

                  // setSelectedItem={({ name, value }) => {
                  //   handleInputFields(name, value);
                  // }}
                  // defaultValue={
                  //   payload && payload[item.name] ? payload[item.name] : ""
                  // }
                  />
                  <DropDown
                    style={defaultStyles.styles.dropDown.largeDropDown}
                    name={input.name}
                    title={input.name}
                    // setSelectedItem={onChange}
                    // list={states}
                    list={[
                      { id: 1, value: "Bookkeeper" },
                      { id: 2, value: "CPA" },
                      { id: 3, value: "Financial Advisor" },
                    ]}
                    displayKey="name"
                  />
                  */}
                </InputGroup1>
              );
            }
          })}
        {/* <InputGroup>
          <Text style={styles.text.labelText} padding="2rem 0 1rem 0 ">
            First Name
          </Text>
          <Input
            placeholder="First Name"
            name="fistName"
            type="text"
            // onChange={(event) => handleContactInfo(event)}
          />
        </InputGroup>
        <InputGroup>
          <Text style={styles.text.labelText} padding="2rem 0 1rem 0 ">
            First Name
          </Text>
          <Input
            placeholder="First Name"
            name="fistName"
            type="date"
            // onChange={(event) => handleContactInfo(event)}
          />
        </InputGroup>
        <InputGroup>
          <Text style={styles.text.labelText} padding="2rem 0 1rem 0 ">
            First Name
          </Text>
          <Input
            placeholder="First Name"
            name="fistName"
            type="file"
            // onChange={(event) => handleContactInfo(event)}
          />
        </InputGroup>

        <InputGroup>
          <Text style={styles.text.labelText} padding="2rem 0 1rem 0 ">
            First Name
          </Text>
          <DropDown
            style={defaultStyles.styles.dropDown.largeDropDown}
            name="test"
            title="test"
            // setSelectedItem= handleTaxCreditInfo,

            list={[
              { id: 1, name: "Bookkeeper" },
              { id: 2, name: "CPA" },
              { id: 3, name: "Financial Advisor" },
            ]}
            displayKey="name"
          />
        </InputGroup> */}

        {/* {fields &&
          fields.map((data, index) => {
            const { value, Component, title, name, onChange, style } = data;
            return (
              <InputGroup>
                <Text style={styles.text.labelText} padding="2rem 0 1rem 0 ">
                  {title || value.title}
                </Text>

                <Component
                  key={index}
                  value={value}
                  name={name}
                  onChange={onChange}
                  style={style}
                />
              </InputGroup>
            );
          })} */}
      </Style.FieldsContainer>
      <NewLoader isLoading={loading} />
      {modalTitle === "View Item" ? (
        <Style.ButtonsContainer
          style={{
            alignItems: "center",
            justifyContent: "center",
            width: "500px",
          }}
        >
          <Style.SaveButton onClick={close}>Close</Style.SaveButton>
        </Style.ButtonsContainer>
      ) : (
        <Style.ButtonsContainer>
          <Style.CancelButton onClick={close}>Cancel</Style.CancelButton>
          <Style.SaveButton disabled={!selectedRowData || loading} onClick={handleSubmit}>
            Save 
            {/*{modalTitle === "Add Item" ? "Add" : "Update"}*/}
          </Style.SaveButton>
        </Style.ButtonsContainer>
      )}
    </Modal>
  );
}

export default CustomModal;
